import React from 'react';
import { Box, Flex, Link, Text } from '@chakra-ui/react';
import { getTransparent } from '../../utils/themer';
import { Color } from '../../theme/color';
import Vendor from '../../vendor.config';

const companyData = {
	name: Vendor.data.company.name,
	address: Vendor.data.company.addressLine.first,
	addressDetails: Vendor.data.company.addressLine.second,
	email: Vendor.data.company.mail,
};

export const CompanyInformation = ({ t, isMobile }: { t: any; isMobile?: boolean }) => {
	return (
		<Flex
			mb="15px"
			fontSize="12px"
			alignItems={isMobile ? 'center' : ''}
			flexDirection="column"
			w="100%"
		>
			<Text
				color={getTransparent(Color.TEXT, 50)}
				fontWeight="600"
			>
				{t('footer.place').toString().toUpperCase()}
			</Text>
			<Text
				textAlign={isMobile ? 'center' : 'left'}
				p="10px 0"
				maxW="167px"
				fontWeight="600"
				fontSize="14px"
				color="text"
			>
				{companyData.name}
				<br />
				{companyData.address}
				<br />
				{companyData.addressDetails}
			</Text>
			<Text
				textAlign={isMobile ? 'center' : 'left'}
				p="10px 0"
				color="text"
			>
				<Link
					_focus={{ boxShadow: 'none' }}
					href={`mailto:${companyData.email}`}
				>
					{companyData.email}
				</Link>
			</Text>
			<Box
				fontSize="14px"
				fontWeight="400"
				textAlign={isMobile ? 'center' : 'left'}
				p="10px 0"
				color={getTransparent(Color.TEXT, 50)}
			>
				{Vendor.data.company.identifiers.map(identifier => (
					<Text key={identifier}>{identifier}</Text>
				))}
			</Box>
		</Flex>
	);
};
